//import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttprequestService } from 'src/app/services/httprequest.service';
import { LoadingController, AlertController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { format, parseISO } from 'date-fns';
import { it } from 'date-fns/locale'
import { Subscription, forkJoin, firstValueFrom, BehaviorSubject } from 'rxjs';
import { LangProvider } from '../../services/lang/lang';
import { StorageService } from '../storage-service.service';
import { serviziRest } from 'src/assets/serviziRest';
import { catchError, filter, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { APPLICATION_SERVER_URL } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CapienzaItem } from 'src/app/main-page-ombrelloni/ricerca-ombrellone/ricerca-ombrellone.page';
/*
  Generated class for the SomeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({ providedIn: 'root' })
export class SomeProvider {
  apiUrl = APPLICATION_SERVER_URL;
  condizioniVenditaPaganti: string = "";
  condizioniVenditaNonPaganti: string = "";
  clientSecret: string = "";
  privacyPolicyUrlEng: any;
  privacyPolicyUrlIta: any;
  hasStripeToken: boolean = false;

  isRistoranteUnoAttivo: boolean = false;
  ordineMinimo: number = 10; // fallback 10€
  dataInizioFormattata: any;
  dataFineFormattata: any;
  liveStreamingData: string = ""; //fallback
  liveStreamingM3u: string = ""; //fallback
  isLiveStreamingDisponibileiOS: boolean = false;
  isLiveStreamingDisponibileAndroid: boolean = false;
  appInManutenzione: boolean;
  oraMaxPrenotabileContantiMattina: any = 10;
  oraMaxPrenotabileContantiPomeriggio: any = 15;
  provenienzaPage: string = "";
  errorMessageStripe: string = "";
  posizioneOrdine: string = ""; // qui, al cehckout, nel caso di ordine bar specifico dove consegnare i drink
  riepilogoOrdine = {};
  // variabili globali per utente
  datiUtente = { "password": "", "email": "", "nome": "", "cognome": "", "telefono": "", "fotoProfilo": "", idUtente: "" };
  avvisoPagamentoContanti: boolean = false;
  carrelloTotale: number;
  fotoProfilo: any;
  serviziRest: any; // qui metter� tutte le chiamate ai servizi, così da poterli avere tutti in un unico file di properties.
  interval: any[];
  countDownDate: any;
  contaInterval: any;
  result = [];
  isCountDownStarted: boolean = false;
  isPagamentiOnlineAbilitato: boolean = false;
  isPagamentiContantiAbilitato: boolean = false;
  isPaymentSheetAbilitato: boolean = false;
  isOldStripePaymentAbilitato: boolean = false;
  isContantiPaymentAbilitato: boolean = false;

  isPaypalDisponibile: boolean = false;
  observableVar: Subscription;
  isUserLoggedIn: boolean = false;
  isPlatformAndroid: boolean = false;
  isPlatformIos: boolean = false;
  isLoginFbIosAvailable: boolean = false;
  isLoginFbAndroidAvailable: boolean = false;
  isEliminaAccountAvailable: boolean = false;
  isGiorniMultipli: boolean = false;
  // oggetti carrello divisi per tipologia
  carrelloOmbrellone: any[];
  carrelloOrdiniBar: any[];
  carrelloRistorante: any[];
  carrelloParcheggio: any[];
  isInventarioMagazzinoEmpty: boolean = false;
  // flag che indica se ho elementi nel carrello o meno, per fare apparire opportuni messaggi a video
  emptyParcheggio: boolean = true;
  emptyRistorante: boolean = true;
  emptyOmbrelloni: boolean = true;
  emptyBar: boolean = true;
  isVersionObsoleta: boolean = false;

  // singole righe di oggetti di uno specifico tipo d'ordine con cui andrò a valorizzare il carrello.

  elementoParcheggio: any;
  elementoOmbrellone: any;
  elementoRistorante: any;
  elementoBar: any;


  // variabili per settare l'intervallo di disponibilità per le prenotazioni

  minDateParcheggio: string;
  minDateRistoranteUno: string;
  minDateOmbrelloni: string;
  maxDateParcheggio: string;
  maxDateRistoranteUno: string;
  maxDateOmbrelloni: string;

  // BehaviorSubject per tracciare quando le date della stagione sono pronte
  private seasonDatesLoadedSubject = new BehaviorSubject<boolean>(false);
  public seasonDatesLoaded$ = this.seasonDatesLoadedSubject.asObservable();
  private seasonDatesLoadingCount = 0;

  // BehaviorSubject per tracciare quando le date del ristorante sono pronte
  private restaurantDatesLoadedSubject = new BehaviorSubject<boolean>(false);
  public restaurantDatesLoaded$ = this.restaurantDatesLoadedSubject.asObservable();
  private restaurantDatesLoadingCount = 0;

  //
  isFasciaOrariaUnoSel: boolean;
  isFasciaOrariaDueSel: boolean;

  loading: any; // variabile per il loader che appare a video

  tokenValue: any;

  nav: any;

  percentualeServizio: number = 0; // per ora lo setto manualmente, dopo invece verr� inserito da DB. Calcola la commissione del servizio all'ombrellone, calcolata sul totale del carrello.

  idOmbrelloneBloccato: any;
  dataOmbrelloneBloccato: any;
  dataOmbrelloneBloccatoFine: any;
  entraIsClicked: boolean = false;



  alertPrenotaOmbrelloneLabel = "";

  alertTempoScadutoLabel = "";
  alertUtentePassErratiLabel = "";
  alertUtentePassRiprovareLabel = "";

  alertLetturaDatiLabel = "";
  alertPagamentoInCorsoLabel = "";
  alertSalvataggioInCorsoLabel = "";
  alertErrorLabel = "";
  alertErrorMessageLabel = "";

  constructor(public lingua: LangProvider,
    private http: HttprequestService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private storage: StorageService,
   /*  public app: App */) {
    this.setLingua();
    this.carrelloParcheggio = [];
    this.carrelloOmbrellone = [];
    this.carrelloRistorante = [];
    this.carrelloOrdiniBar = [];
    this.interval = [];

    this.fotoProfilo = "";
    // this.datiUtente = [];
    this.elementoParcheggio = "";
    this.elementoOmbrellone = "";
    this.elementoRistorante = "";
    this.elementoBar = "";
    //console.log(this.fotoProfilo);
    // console.log(this.datiUtente);
    this.carrelloTotale = 0;
    this.isFasciaOrariaUnoSel = false;
    this.isFasciaOrariaDueSel = false;
    this.isCountDownStarted = false;

    this.idOmbrelloneBloccato = '';
    this.dataOmbrelloneBloccato = '';
    this.dataOmbrelloneBloccatoFine = '';
    this.minDateOmbrelloni = '';

    // Inizializza direttamente i primi passi
    this.initFirstSteps();
  }


  initFirstSteps() {
    this.serviziRest = serviziRest;
    //  this.minDateParcheggio = this.creaData();     // serve a stabilire TODAY come primo giorno utile per prenotare il parcheggio
    this.minDateRistoranteUno = this.creaData();
    this.maxDateRistoranteUno = "2023-09-30"; //qui inseriro il giorno massimo per la prenotazione.


    //console.log(this.minDateRistorante);  // serve a stabilire TODAY come primo giorno utile per prenotare il parcheggio
    this.storage.get('token').then((val) => {
      this.tokenValue = val;
      this.calcolaFineStagione();
      this.calcolaInizioStagione();
      this.calcolaFineStagioneRistorante();
      this.calcolaInizioStagioneRistorante();
      this.getPrivacyUrl();
    });
  }
  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
  async stoppaLoader() {
    if (this.loading) {
      await this.loading.dismiss()
        .then(() => {
          this.loading = null;
        })
        .catch(e => console.log(e));
    }
  }


  calcolaDataMinima(dataSplittata) {
    let today = this.creaData();
    let data = today.split('-');
    let anno = data[0];
    let mese = data[1];
    let giorno = data[2];
    today = anno + mese + giorno;
    if (parseInt(today) >= parseInt(dataSplittata)) {
      this.minDateOmbrelloni = this.creaData();
    }
  }
  calcolaDataMinimaRistorante(dataSplittata) {
    const today = this.creaData();
    const data = today.split('-');
    const anno = data[0];
    const mese = data[1];
    const giorno = data[2];
    const todayFormatted = anno + mese + giorno;
    if (parseInt(todayFormatted) >= parseInt(dataSplittata)) {
      this.minDateRistoranteUno = this.creaData();
    }
  }


  async isEliminaAccountDisponibile() {
    await this.fetchBooleanParameter(
      this.apiUrl + "/singlefin-ws/rest/public/users/getParametroInt?idParametro=1026",
      'isEliminaAccountAvailable',
      true // isPublic
    );
  }


  formatCheckoutDate(dataSceltaInizio, dataSceltaFine) {
    this.dataInizioFormattata = format(parseISO(dataSceltaInizio), 'dd MMM yyyy', { locale: this.lingua.dateFnsLocale });
    this.dataFineFormattata = format(parseISO(dataSceltaFine), 'dd MMM yyyy', { locale: this.lingua.dateFnsLocale });
  }


  async getIsLiveStreamingDisponibile() {
    await this.fetchMultipleParameters([
      {
        endpoint: this.apiUrl + this.serviziRest.isLiveStreamingAvailableiOS,
        propertyName: 'isLiveStreamingDisponibileiOS',
        convertToBoolean: true
      },
      {
        endpoint: this.apiUrl + this.serviziRest.isLiveStreamingAvailableAndroid,
        propertyName: 'isLiveStreamingDisponibileAndroid',
        convertToBoolean: true
      }
    ]);

    // Chiamata successiva dopo aver ottenuto i dati
    this.getLiveStreamingData();
  }

  async getLiveStreamingData() {
    if (this.isLiveStreamingDisponibileAndroid && this.isPlatformAndroid) {
      await this.fetchStringParameter(
        this.apiUrl + this.serviziRest.getLiveStreamingData,
        'liveStreamingData',
        false,
        false,
        '' // default value
      );
    }

    if (this.isLiveStreamingDisponibileiOS && this.isPlatformIos) {
      await this.fetchStringParameter(
        this.apiUrl + this.serviziRest.getLiveStreamingM3u,
        'liveStreamingM3u',
        false,
        false,
        '' // default value
      );
    }
  }

  calcolaInizioStagioneRistorante(): void {
    this.restaurantDatesLoadingCount++;
    this.http.doGetTextPublic(this.apiUrl + this.serviziRest.calcolaInizioStagioneRistoranteUno).subscribe({
      next: (data) => {
        if (data) {
          this.minDateRistoranteUno = data;
          const dataSplittata = data.split('-');
          const anno = dataSplittata[0];
          const mese = dataSplittata[1];
          const giorno = dataSplittata[2];
          const dataFormattata = anno + mese + giorno;
          this.calcolaDataMinimaRistorante(dataFormattata);
        } else {
          this.minDateRistoranteUno = this.creaData();
        }
        this.checkRestaurantDatesLoaded();
      },
      error: (error) => {
        console.error('Errore nel calcolo inizio stagione ristorante:', error);
        this.minDateRistoranteUno = this.creaData();
        this.checkRestaurantDatesLoaded();
      }
    });
  }

  calcolaFineStagioneRistorante(): void {
    this.restaurantDatesLoadingCount++;
    this.http.doGetTextPublic(this.apiUrl + this.serviziRest.calcolaFineStagioneRistoranteUno).subscribe({
      next: (data) => {
        this.maxDateRistoranteUno = data || "2028-09-30";
        this.checkRestaurantDatesLoaded();
      },
      error: (error) => {
        console.error('Errore nel calcolo fine stagione ristorante:', error);
        this.maxDateRistoranteUno = "2028-09-30";
        this.checkRestaurantDatesLoaded();
      }
    });
  }
  calcolaInizioStagione(): void {
    this.seasonDatesLoadingCount++;
    this.http.doGetTextPublic(this.apiUrl + this.serviziRest.calcolaInizioStagione).subscribe({
      next: (data) => {
        if (data) {
          this.minDateOmbrelloni = data;
          const dataSplittata = data.split('-');
          const anno = dataSplittata[0];
          const mese = dataSplittata[1];
          const giorno = dataSplittata[2];
          const dataFormattata = anno + mese + giorno;
          this.calcolaDataMinima(dataFormattata);
        } else {
          this.minDateOmbrelloni = this.creaData();
        }
        this.checkSeasonDatesLoaded();
      },
      error: (error) => {
        console.error('Errore nel calcolo inizio stagione:', error);
        this.minDateOmbrelloni = this.creaData();
        this.checkSeasonDatesLoaded();
      }
    });
  }

  calcolaFineStagione(): void {
    this.seasonDatesLoadingCount++;
    this.http.doGetTextPublic(this.apiUrl + this.serviziRest.calcolaFineStagione).subscribe({
      next: (data) => {
        this.maxDateOmbrelloni = data || "2026-09-15";
        this.checkSeasonDatesLoaded();
      },
      error: (error) => {
        console.error('Errore nel calcolo fine stagione:', error);
        this.maxDateOmbrelloni = "2026-09-15";
        this.checkSeasonDatesLoaded();
      }
    });
  }

  private checkSeasonDatesLoaded(): void {
    this.seasonDatesLoadingCount--;
    if (this.seasonDatesLoadingCount === 0) {
      console.log('Date stagione caricate:', {
        minDateOmbrelloni: this.minDateOmbrelloni,
        maxDateOmbrelloni: this.maxDateOmbrelloni
      });
      this.seasonDatesLoadedSubject.next(true);
    }
  }

  private checkRestaurantDatesLoaded(): void {
    this.restaurantDatesLoadingCount--;
    if (this.restaurantDatesLoadingCount === 0) {
      console.log('Date ristorante caricate:', {
        minDateRistoranteUno: this.minDateRistoranteUno,
        maxDateRistoranteUno: this.maxDateRistoranteUno
      });
      this.restaurantDatesLoadedSubject.next(true);
    }
  }

  async waitForSeasonDates(): Promise<void> {
    if (this.seasonDatesLoadedSubject.value) {
      return Promise.resolve();
    }
    return firstValueFrom(
      this.seasonDatesLoaded$.pipe(
        filter((isLoaded) => isLoaded === true),
        take(1),
        catchError(() => of(true))
      )
    ).then(() => { });
  }

  async waitForRestaurantDates(): Promise<void> {
    if (this.restaurantDatesLoadedSubject.value) {
      return Promise.resolve();
    }
    return firstValueFrom(
      this.restaurantDatesLoaded$.pipe(
        filter((isLoaded) => isLoaded === true),
        take(1),
        catchError(() => of(true))
      )
    ).then(() => { });
  }

  async isRistoranteAttivoFunc() {
    await this.fetchBooleanParameter(
      this.apiUrl + "/singlefin-ws/rest/public/users/getParametroInt?idParametro=101",
      'isRistoranteUnoAttivo',
      true // isPublic
    );
  }

  async fetchOrdineMinimo(): Promise<number> {
    const result = await this.fetchParameter<number>(
      this.apiUrl + "/singlefin-ws/rest/public/users/getParametroInt?idParametro=2003",
      'ordineMinimo',
      {
        isPublic: true,
        defaultValue: 10
      }
    );
    const parsed = Number(result);
    this.ordineMinimo = (!isNaN(parsed) && parsed >= 0) ? parsed : 10;
    return this.ordineMinimo;
  }



  /*   calcolaOrarioMaxPrenotazContanti() {
      var headers = new Headers();
  
      this.http.doGet(this.apiUrl + "/singlefin-ws/rest/public/users/getParametroInt?idParametro=1003").subscribe(data => {
        this.oraMaxPrenotabileContantiMattina = data;
    
      }, error => {
        if (error.status == 0) {
        } else {
        }
  
      });
  
  
      this.http.doGet(this.apiUrl + "/singlefin-ws/rest/public/users/getParametroInt?idParametro=1004").subscribe(data => {
        this.oraMaxPrenotabileContantiPomeriggio = data;
      }, error => {
        if (error.status == 0) {
        } else {
        }
  
      });
  
  
    } */




  getCondizioniVendita() {
    var headers = new Headers();
    // headers.append('Authorization', 'Bearer ' + this.tokenValue);


    this.http.doGetTextBearer(this.apiUrl + "/singlefin-ws/rest/public/users/getParametroString?idParametro=1039").subscribe(res => {
      let condizioniDiVendita = res.split('|');
      const lang = (this.lingua.languageSelected || 'IT').toUpperCase();
      const index = lang === 'IT' ? 0 : lang === 'EN' ? 1 : 2;
      this.condizioniVenditaPaganti = condizioniDiVendita[index] ?? condizioniDiVendita[0];
    }, error => {
      console.log(error);
    });

    this.http.doGetTextBearer(this.apiUrl + "/singlefin-ws/rest/public/users/getParametroString?idParametro=1038").subscribe(res => {
      let condizioniDiVenditaNonPaganti = res.split('|');
      const lang = (this.lingua.languageSelected || 'IT').toUpperCase();
      const index = lang === 'IT' ? 0 : lang === 'EN' ? 1 : 2;
      this.condizioniVenditaNonPaganti = condizioniDiVenditaNonPaganti[index] ?? condizioniDiVenditaNonPaganti[0];
    }, error => {
      console.log(error);
    });

  }



  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase().trim() + string.slice(1).toLowerCase().trim();
  }



  /* Serve a creare una data nel formato AAAA-MM-GG partendo da un Sysdate, per poterlo far leggere alle sezioni contenenti un DATETIME Ionic (es. per prenotazione ombrelloni) */


  creaData() {
    var d = new Date();
    var mese = '' + (d.getMonth() + 1);
    var giorno = '' + d.getDate();
    var anno = d.getFullYear();
    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    return anno + "-" + mese + "-" + giorno;

  }

  creaDataTomorrow(today) {
    let data = today.split('-');
    let anno = data[0];
    let mese = data[1];
    let giorno = data[2];
    let d = new Date(anno, mese, giorno);
    mese = '' + (d.getMonth());
    giorno = '' + (d.getDate() + 1);
    anno = d.getFullYear();
    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    return anno + "-" + mese + "-" + giorno;


  }


  /* Funzione per sbloccare un ombrellone, bloccato per procedere con l'acquisto */

  getUserStatus() {
    return this.isUserLoggedIn;
  }
  sbloccaOmbrellone(dataInizio, dataFine, idOmbrellone, idUser, idFasciaOraria) {

    this.storage.get('token').then((val) => {
      this.tokenValue = val;
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + this.tokenValue);


      let postData = {
        "dataInizio": dataInizio,
        "dataFine": dataFine,
        "idOmbrellone": idOmbrellone,
        "idUser": idUser,
        "idFasciaOraria": idFasciaOraria
      };
      this.http.doPostApplicationJsonBearer(this.apiUrl + this.serviziRest.sbloccaOmbrellone, postData)
        .subscribe(() => {
          //  this.tokenValue = data;

          for (let i in this.interval) {
            //      console.log("partito clearInterval da some.ts");
            clearInterval(this.interval[i]);
          }
          this.stoppaLoader();
        }, error => {
          this.stoppaLoader();
          if (error.status == 0) {
            this.alertAddressError();
          } else if (error.status == 400 || error.status == 401 || error.status == 403) {
            this.alertWrongCredentials();
          } else {
            this.alertGenericError();
          }
          //  console.log(error);
        })

    });

  }


  /* Gestione del timer per il timeout dell'acquisto di un ombrellone */


  /* Gestione del timer per il timeout dell'acquisto di un ombrellone - CODICE RIMOSSO */

  // Methods removed: countdown, eseguiSvuotaCarrello, stopCountdown, svuotaCarrelloOmbrellone, svuotaOmbrelloneAlert




  async registrazioneUtenteAlert() {
    this.loading = await this.loadingCtrl.create({
      spinner: 'bubbles',
      duration: 10000,
      message: this.alertLetturaDatiLabel,
      translucent: true,
    });
    return await this.loading.present();
  }




  /* Parte relativa ai messaggi d'errore riguardanti il TOKEN d'accesso */
  async alertAddressError() {
    this.setLingua();
    const alert = await this.alertCtrl.create({
      header: this.alertErrorLabel,
      message: this.alertErrorMessageLabel,
      buttons: ['OK']
    });

    await alert.present();
  }

  async alertError(message) {
    this.setLingua();
    const alert = await this.alertCtrl.create({
      header: this.alertErrorLabel,
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }


  async alertGenericError() {
    this.setLingua();
    const alert = await this.alertCtrl.create({
      header: this.alertErrorLabel,
      message: this.alertErrorMessageLabel,
      buttons: ['OK']
    });

    await alert.present();
  }

  async alertWrongCredentials() {
    this.setLingua();
    const alert = await this.alertCtrl.create({
      header: this.alertUtentePassErratiLabel,
      message: this.alertUtentePassRiprovareLabel,
      buttons: ['OK']
    });

    await alert.present();
  }


  async mostraLoader(provenienza = '') {
    console.log('chiamato mostra loader ' + provenienza);
    this.loading = await this.loadingCtrl.create({
      spinner: 'bubbles',
      duration: 3000,
      message: this.alertLetturaDatiLabel,
      translucent: true,
    });
    return await this.loading.present();
  }



  async mostraLoaderNoTesti(provenienza = '') {
    console.log('chiamato mostra loader dentro some service no testi ' + provenienza);
    this.loading = await this.loadingCtrl.create({
      spinner: 'dots',
      duration: 3000,
      message: '',
      translucent: true,
    });
    return await this.loading.present();
  }

  async invioPagamentoLoader() {
    this.loading = await this.loadingCtrl.create({
      spinner: 'bubbles',
      duration: 2500,
      message: this.alertPagamentoInCorsoLabel,
      translucent: true,
    });
    return await this.loading.present();
  }
  async updateDatiLoader() {
    this.loading = await this.loadingCtrl.create({
      spinner: 'bubbles',
      duration: 4500,
      message: this.alertSalvataggioInCorsoLabel,
      translucent: true,
    });
    return await this.loading.present();
  }

  rimuoviLoader() {
    if (this.loading != null) {
      this.loading.dismiss().then();
    }
  }



  logout() {
    this.storage.set('showModale', '');
    this.storage.set('idUtente', '');

    this.storage.set('tutorialCompleted', ''); // Reset tutorial preference
    this.isUserLoggedIn = false;
    this.storage.set('locale_lang', '').then((val) => {
    });



    if (this.observableVar != undefined) {
      this.observableVar.unsubscribe();
    }

    // Remove API token
    this.storage.set('token', '').then((val) => {
      //   console.log("Stato Token (dentro logout): " + val);

    });

    this.storage.set('username', '').then((val) => {
      //   console.log("Stato username (dentro logout): " + val);

    });


  }

  async getIsPagamentoPaypal() {
    await this.fetchBooleanParameter(
      this.apiUrl + this.serviziRest.isPaypalDisponibile,
      'isPaypalDisponibile',
      false, // richiede Bearer token
      true   // mostra errori
    );
  }
  async getIsPagamentoContanti() {
    await this.fetchBooleanParameter(
      this.apiUrl + this.serviziRest.pagaAncheContanti,
      'isPagamentiContantiAbilitato',
      false, // richiede Bearer token
      true   // mostra errori
    );
  }


  async getMetodiPagamentoCarrello() {
    await this.fetchMultipleParameters([
      {
        endpoint: this.apiUrl + this.serviziRest.getIsPaymentSheetAvailable,
        propertyName: 'isPaymentSheetAbilitato',
        convertToBoolean: true,
        defaultValue: 0
      },
      {
        endpoint: this.apiUrl + this.serviziRest.getIsPagamentiContantiAvailable,
        propertyName: 'isContantiPaymentAbilitato',
        convertToBoolean: true,
        defaultValue: 0
      },
      {
        endpoint: this.apiUrl + this.serviziRest.getOldStripePaymentAvailable,
        propertyName: 'isOldStripePaymentAbilitato',
        convertToBoolean: true,
        defaultValue: 0
      }
    ]);

    console.log({
      isPaymentSheetAbilitato: this.isPaymentSheetAbilitato,
      isContantiPaymentAbilitato: this.isContantiPaymentAbilitato,
      isOldStripePaymentAbilitato: this.isOldStripePaymentAbilitato
    });
  }

  async getIsPagamentoOnline() {
    await this.fetchBooleanParameter(
      this.apiUrl + this.serviziRest.pagaSoloContanti,
      'isPagamentiOnlineAbilitato',
      false, // richiede Bearer token
      true   // mostra errori
    );
  }



  getDatiUtente(email) {

    this.storage.get('token').then((val) => {

      this.tokenValue = val;
      // console.log(this.tokenValue);
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + this.tokenValue);

      let postData = {
        "email": email

      };

      this.http.doPostApplicationJsonBearer(this.apiUrl + this.serviziRest.getUtente, postData)
        .subscribe(data => {
          let tempUserdata = data;
          tempUserdata.stripeToken == 1 ? this.hasStripeToken = true : false;
          this.datiUtente.nome = tempUserdata.nome;
          this.datiUtente.cognome = tempUserdata.cognome;
          this.datiUtente.telefono = tempUserdata.telefono;
          this.datiUtente.email = email;
          this.datiUtente.fotoProfilo = tempUserdata.image;
          if (tempUserdata.image != null && tempUserdata.image != undefined && tempUserdata.image != '') {
            this.fotoProfilo = tempUserdata.image;
          } else {
            this.fotoProfilo = '';
          }

        }, error => {
          // console.log(error.status);
          if (error.status == 0) {
            this.alertAddressError();
          } else if (error.status == 400 || error.status == 401 || error.status == 403) {
            this.alertWrongCredentials();
          } else {
            this.alertGenericError();
          }

          //  console.log(error);
        });
    });

  }


  setDatiUtente() {
    this.updateDatiLoader();

    this.storage.get('token').then((val) => {

      this.tokenValue = val;
      // console.log(this.tokenValue);
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + this.tokenValue);

      let postData = {
        //    "email": datiUtente.email,
        //      "password" : "",
        "nome": this.datiUtente.nome,
        "cognome": this.datiUtente.cognome,
        "telefono": this.datiUtente.telefono,
        "image": this.datiUtente.fotoProfilo

      };


      this.http.doPostApplicationJsonBearer(this.apiUrl + this.serviziRest.setUtente, postData)
        .subscribe(data => {
          this.stoppaLoader();
          // console.log(data);
          // console.log("tutto ok aggiornamento dati profilo");
          this.fotoProfilo = this.datiUtente.fotoProfilo;
          this.getDatiUtente(this.datiUtente.email);

        }, error => {
          this.stoppaLoader();
          // console.log(error.status);
          if (error.status == 0) {
            this.alertAddressError();
          } else if (error.status == 400 || error.status == 401 || error.status == 403) {
            this.alertWrongCredentials();
          } else {
            this.alertGenericError();
          }

          // console.log(error);
        });
    });

  }


  setLingua() {
    const lang = this.lingua.languageSelected;
    const suffix = `_${lang}`;

    const translations = {
      alertPrenotaOmbrelloneLabel: `alertPrenotaOmbrellone${suffix}`,
      alertTempoScadutoLabel: `alertTempoScaduto${suffix}`,
      alertUtentePassErratiLabel: `alertUtentePassErrati${suffix}`,
      alertUtentePassRiprovareLabel: `alertUtentePassRiprovare${suffix}`,
      alertLetturaDatiLabel: `alertLetturaDati${suffix}`,
      alertPagamentoInCorsoLabel: `alertPagamentoInCorso${suffix}`,
      alertSalvataggioInCorsoLabel: `alertSalvataggioInCorso${suffix}`,
      alertErrorLabel: `alertError${suffix}`,
      alertErrorMessageLabel: `alertErrorMessage${suffix}`
    };

    Object.keys(translations).forEach(key => {
      this[key] = this.lingua[translations[key]];
    });
  }

  async getPrivacyUrl() {
    try {
      const [privacyPolicyIta, privacyPolicyEng] = await Promise.all([
        firstValueFrom(this.http.doGetTextPublic(this.apiUrl + this.serviziRest.getPrivacyUrlIta)),
        firstValueFrom(this.http.doGetTextPublic(this.apiUrl + this.serviziRest.getPrivacyUrlEng))
      ]);

      this.privacyPolicyUrlIta = this.normalizeExternalUrl(privacyPolicyIta);
      this.privacyPolicyUrlEng = this.normalizeExternalUrl(privacyPolicyEng);
    } catch (error) {
      console.error('Error fetching privacy urls:', error);
      this.privacyPolicyUrlIta = '';
      this.privacyPolicyUrlEng = '';
    }
  }
  validaCapienza(data: CapienzaItem) {
    return this.http.doPostApplicationJsonBearer(
      this.apiUrl + this.serviziRest.validaCapienza,
      data);
  }

  /**
   * ========================================
   * METODI UTILITY GENERICI PER PARAMETRI
   * ========================================
   */

  /**
   * Metodo generico per fetchare un parametro dal server
   * @param endpoint L'endpoint completo da chiamare
   * @param propertyName Nome della proprietà della classe da aggiornare
   * @param options Opzioni di configurazione
   */
  private async fetchParameter<T>(
    endpoint: string,
    propertyName: keyof SomeProvider,
    options: {
      isPublic?: boolean;
      convertToBoolean?: boolean;
      sanitize?: boolean;
      defaultValue?: T;
      showErrors?: boolean;
    } = {}
  ): Promise<T> {
    const {
      isPublic = false,
      convertToBoolean = false,
      sanitize = false,
      defaultValue = null,
      showErrors = false
    } = options;

    try {
      const token = await this.storage.get('token');
      this.tokenValue = token;

      let result: any;

      if (isPublic) {
        result = await firstValueFrom(this.http.doGet(endpoint));
      } else {
        result = await firstValueFrom(this.http.doGetApplicationJsonBearer(endpoint));
      }

      // Conversione del risultato
      let processedResult: any = result;

      if (convertToBoolean) {
        processedResult = result == 1 || result === true;
      }

      if (sanitize) {
        processedResult = this.sanitizer.bypassSecurityTrustResourceUrl(result);
      }

      // Aggiorna la proprietà della classe
      (this as any)[propertyName] = processedResult;

      return processedResult;
    } catch (error: any) {
      console.error(`Error fetching parameter ${String(propertyName)}:`, error);

      if (showErrors) {
        if (error.status === 0) {
          this.alertGenericError();
        } else {
          this.alertGenericError();
        }
      }

      // Imposta valore di default
      if (defaultValue !== null) {
        (this as any)[propertyName] = defaultValue;
      }

      return defaultValue as T;
    }
  }

  /**
   * Fetcha un parametro booleano (getParametroInt con conversione a boolean)
   */
  private async fetchBooleanParameter(
    endpoint: string,
    propertyName: keyof SomeProvider,
    isPublic: boolean = false,
    showErrors: boolean = false
  ): Promise<boolean> {
    return this.fetchParameter<boolean>(endpoint, propertyName, {
      isPublic,
      convertToBoolean: true,
      showErrors,
      defaultValue: false
    });
  }

  /**
   * Fetcha un parametro stringa
   */
  private async fetchStringParameter(
    endpoint: string,
    propertyName: keyof SomeProvider,
    isPublic: boolean = false,
    sanitize: boolean = false,
    defaultValue: string = ''
  ): Promise<string> {
    return this.fetchParameter<string>(endpoint, propertyName, {
      isPublic,
      sanitize,
      defaultValue
    });
  }

  /**
   * Fetcha multipli parametri in parallelo usando forkJoin
   */
  private fetchMultipleParameters(
    configs: Array<{
      endpoint: string;
      propertyName: keyof SomeProvider;
      isPublic?: boolean;
      convertToBoolean?: boolean;
      sanitize?: boolean;
      defaultValue?: any;
    }>
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.storage.get('token').then((token) => {
        this.tokenValue = token;

        const requests: { [key: string]: any } = {};

        configs.forEach((config, index) => {
          const obs = config.isPublic
            ? this.http.doGet(config.endpoint).pipe(catchError(() => of(config.defaultValue ?? 0)))
            : this.http.doGetApplicationJsonBearer(config.endpoint).pipe(catchError(() => of(config.defaultValue ?? 0)));

          requests[`req_${index}`] = obs;
        });

        forkJoin(requests).subscribe({
          next: (results: any) => {
            configs.forEach((config, index) => {
              let result: any = results[`req_${index}`];

              if (config.convertToBoolean) {
                result = result == 1 || result === true;
              }

              if (config.sanitize) {
                result = this.sanitizer.bypassSecurityTrustResourceUrl(result);
              }

              (this as any)[config.propertyName] = result;
            });
            resolve();
          },
          error: (error) => {
            console.error('Error fetching multiple parameters:', error);
            this.alertGenericError();
            reject(error);
          }
        });
      });
    });
  }

  private normalizeExternalUrl(value: unknown): string {
    if (typeof value !== 'string') {
      return '';
    }

    let normalized = value.trim();

    // Handles API responses like "\"https://example.com/...\""
    if (normalized.startsWith('"') && normalized.endsWith('"')) {
      try {
        normalized = JSON.parse(normalized);
      } catch {
        normalized = normalized.slice(1, -1);
      }
    }

    normalized = normalized.trim();

    if (!/^https?:\/\//i.test(normalized)) {
      return '';
    }

    return normalized;
  }


}
